// App version used to label Sentry releases when REACT_APP_SENTRY_RELEASE isn't set.
// Bump this on notable releases, or set REACT_APP_SENTRY_RELEASE per deploy for precise tracking.
export const APP_VERSION = "1.0.0";
